"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _itinerary = _interopRequireDefault(require("./itinerary.factory"));
var _filterParams = require("../utils/filter-params.utils");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var itineraryForAgentFactory = function itineraryForAgentFactory(_ref) {
  var itinerary = _ref.itinerary,
    legHashMap = _ref.legHashMap,
    searchRequest = _ref.searchRequest,
    vendor = _ref.vendor,
    $currency = _ref.$currency;
  var it = (0, _itinerary.default)({
    itinerary: itinerary,
    legHashMap: legHashMap,
    searchRequest: searchRequest,
    vendor: vendor,
    $currency: $currency
  });
  return _objectSpread(_objectSpread({}, it), {}, {
    filterParams: (0, _filterParams.extractFlightFilterParams)({
      totalPrice: it.price.oldTotal || it.price.total,
      legs: it.legs,
      hasInsuranceCoverage: it.hasInsuranceCoverage,
      hasBaggageOnly: it.hasCheckInBaggage,
      isFlex: it.isFlex
    })
  });
};
var _default = exports.default = itineraryForAgentFactory;